export const room = {
  groupName: {
    label: 'Nom du groupe',
    create: 'Imagine un nom de groupe',
  },
  name: {
    label: 'Nom',
    your: 'Ton nom',
  },
  actions: {
    create: 'Prépare une pièce',
    scanCode: 'Scanne ce code de pièce',
    enter: 'Entre dans la pièce',
    start: 'Commence par la première pièce',
  },

  members: 'Membres du groupe dans la pièce',

  welcome: {
    part1: 'Bienvenue, {{name}},',
    part2: 'attende un instant avant que le jeu commence ',
  },

  instructions: {
    read: 'Maintenant, lise en silence les exemples sur ton smartphone',
    ready:
      "Quand tout le monde est prêt, tu peux entrer dans la pièce. Explique ton exemple quand il apparaît à l'écran. Choisis tes propres mots. Clique sur les boutons de navigation en haut de l'écran pour passer à l'exemple suivant.",
    listen:
      "Maintenant, écoute les autres. C'est le tour de tes camarades de groupe.",
    continue:
      "On a vu passer tous les exemples. Bien joué ! Poursuive maintenant dans l'EDUbox.",
  },
  closed: 'La pièce est fermée',
};
